module Meevo.Plugins.SmartCenter {

    import IncludedEmployeeEnum = Meevo.Model.IncludedEmployeeEnum;
    import BusyService = Meevo.Components.Busy.BusyService;
    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;

    type IncludedEmployeeValue = 'AllEmployees' | 'SpecificEmployee' | 'LoggedInEmployee';

    interface IParameters {
        includedEmployee: {
            label: string;
            labelKey: string;
            parameterType: string;
            parameterValue: IncludedEmployeeValue;
            parameterDisplayName: string;
        };
        employee: {
            label: string;
            labelKey: string;
            parameterType: string;
            isHidden: boolean;
            parameterValue: string;
        };
    }

    class FilterCriteria {
        service?: Meevo.Model.Service;
        employeeUser?: Meevo.Model.Employee;
        rating?: number;

        constructor(private params: FilterCriteria = <FilterCriteria>{}, private parameterValue: string) {
            _.assign(this, params);
        }
    }

    class MeevoFiveStarRatingTileComponent implements ng.IComponentController {

        static $inject = [
            'meevo.components.common.DataService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.IdentityService'
        ];

        private response: any;
        private average: any;

        public parameters: IParameters;
        public tileId: number;
        public showTable: boolean = false;
        public arrayResults: IDataMaintenanceInfiniteList;
        public businessTypeId: string;
        public homeLocationId: number;

        public filterCriteria: FilterCriteria;

        get employeeId(): string {
            switch (this.parameters.includedEmployee.parameterValue) {
                case 'AllEmployees':
                    return this.filterCriteria.employeeUser ? this.filterCriteria.employeeUser.id : null;
                case 'LoggedInEmployee':
                    return this.identityService.current().userId.toString();
                case 'SpecificEmployee':
                    return this.parameters.employee.parameterValue;
                default:
                    return null;
            }
        }

        get request() {
            return {
                itemsPerPage: 25,
                criteria: {
                    pageNumber: 0,
                    smartCenterBusinessTypeId: this.businessTypeId,
                    smartCenterLocationId: this.homeLocationId,
                    serviceId: this.filterCriteria.service && this.filterCriteria.service.id,
                    rating: this.filterCriteria.rating ? this.filterCriteria.rating : null,
                    itemsPerPage: 25,
                    employeeUserId: this.employeeId,
                    includeDetails: false,
                    isHidden: null,
                    isDeleted: false,
                    includeEmptyRating: true
                }
            };
        }

        get includedEmployeeEnum(): typeof IncludedEmployeeEnum {
            return IncludedEmployeeEnum;
        }

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private busyService: BusyService,
            private identityService: Meevo.Components.Common.IIdentityService) {
        }

        $onInit() {
            this.filterCriteria = new FilterCriteria(<FilterCriteria>{}, this.parameters.includedEmployee.parameterValue);
            this.getRatings();
        }

        private getRatings() {
            this.showTable = false;

            this.dataService.customMethodData(`api/SmartTile/${this.tileId}/List`, 'POST', this.request)
                .then(response => {
                    let element, listRating = [];

                    for (let i = 1; i < 6; i++) {
                        let findElement = _.find(response.data, (item: any) => {
                            return item.Rating === i
                        })

                        if (findElement) {
                            element = {
                                label: i + ' stars',
                                value: findElement.RatingCount
                            }
                        } else {
                            element = {
                                label: i + ' stars',
                                value: 0
                            }
                        }
                        listRating.push(element);
                    }
                    this.response = listRating.reverse();
                    this.average = response.data;
                });
        }

        private getAllReviews() {
            let request = this.request;
            request.criteria.includeDetails = true;
            this.busyService.start();
            this.arrayResults = this.getResults(`SmartTile/${this.tileId}`, null);
            this.arrayResults.initSearch(request).then((response) => {
                if (Number(response) > 0) {
                    this.showTable = true;
                }

                this.busyService.stop();
            });
        }

        public getResults(url, onPageLoad) {
            return new Meevo.Components.BaseClasses.PagedResults(this.dataService, url, onPageLoad);
        }

        public ratingDropdown: Array<any> = [
            {value: null, label: 'All'},
            {value: 1, label: '1 star'},
            {value: 2, label: '2 stars'},
            {value: 3, label: '3 stars'},
            {value: 4, label: '4 stars'},
            {value: 5, label: '5 stars'}
        ];

        public isRatingStarsTile(value): number {
            return value ? value : 0;
        }
    }

    angular.module('meevo.plugins.smartCenter')
        .component('meevoFiveStarRatingTileComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/smartCenter/components/five-star-rating-tile/five-star-rating-tile.component.html',
            controller: MeevoFiveStarRatingTileComponent,
            controllerAs: '$ctrl',
            bindings: {
                parameters: '<',
                tileId: '@',
                businessTypeId: '@',
                homeLocationId: '@',
            }
        });
}
